module.exports = "./img/ba09ab3ab661fa976111b793e8121ddb.jpg";